module.exports = __webpack_public_path__ + "static/media/pic1.044b43dc.png";